import { vuexFilterBase } from '@/store/composition/utils/query/filter'
import { vuexPaginationBase } from '@/store/composition/utils/query/pagination'
import { vuexSortBase } from '@/store/composition/utils/query/sort'
import { vuexLoadingBase } from '@/store/composition/utils/loading'
import { loadList } from '@/store/composition/utils/data/actions'
import { HOURS_URL } from '@/api/usersApi'
import { showAlertError, showAlertSuccess } from '@/utils/store/alert'
import { configMultipart, url } from '@/store'
import axios from 'axios'

const state = () => ({
  ...vuexFilterBase.createState(),
  ...vuexPaginationBase.createState(),
  ...vuexSortBase.createState(),
  ...vuexLoadingBase.createState(),

  urlApi: HOURS_URL,
  list: [],
  tableHeaders: [
    {
      title: 'Дата и время входа',
      isSortable: true,
      sortName: 'started_at'
    },
    {
      title: 'Дата и время выхода',
      isSortable: false,
      sortName: 'finished_at'
    },
    {
      title: 'Время работы за день',
      isSortable: false
    }
  ],
  pagination: {
    pages: [],
    perPage: 100,
    currentPage: 1
  }
})

const getters = {
  ...vuexPaginationBase.createGetters(),
  ...vuexLoadingBase.createGetters(),
  getTableHeaders: state => state.tableHeaders,
  visibleTable: (state) => state.list.length,
  getList: (state) => {
    return state.list.map(item => {
      const workTime = ((new Date(item.finished_at)).getTime() - (new Date(item.started_at)).getTime()) / 3600000
      return {
        id: item.id,
        values: [
          { data: item.started_at, mod: 'date' },
          { data: item.finished_at, mod: 'date' },
          workTime || '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexFilterBase.createMutations(),
  ...vuexPaginationBase.createMutations(),
  ...vuexSortBase.createMutations(),
  ...vuexLoadingBase.createMutations(),
  SET_LIST: (state, list) => {
    state.list = list
  },
  RESET_STORE: (state) => {
    state.list = []

    // query params
    state.sort = {
      name: 'started_at',
      descending: true
    }
  }
}

const actions = {
  loadList,
  ...vuexFilterBase.createActions(),
  ...vuexPaginationBase.createActions(),
  ...vuexSortBase.createActions(),

  async importHours ({ commit }, params) {
    try {
      const formData = new FormData()
      formData.append('file', params.file)
      commit('SET_IS_LOADING', true)

      const res = await axios.post(`${url}/${HOURS_URL}?&search[UserId]=${params.UserId}&search[Month]=${params.Month}`, formData, configMultipart)
      commit('SET_LIST', res.data.data)
      showAlertSuccess('Файл успешно импортирован')
    } catch (e) {
      const error = { message: 'Ошибка импорта файла' }
      showAlertError(error)
    } finally {
      commit('SET_IS_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
